<template>
  <v-app>
      <router-view v-if="!embedded" name="header" v-model="expandOnHover" />
      <router-view v-if="!embedded" name="sideBar" :expand-on-hover.sync="expandOnHover" />
      <v-main>
      <v-dialog v-model="versionMismatch" max-width="430" persistent>
        <v-card>
          <v-card-title>A new version is ready</v-card-title>
          <v-card-text>Reload the application to continue with the latest version.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="versionMismatch = false">Later</v-btn>
            <v-btn color="primary" @click="reloadApplication">Reload now</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
       <v-overlay style='z-index:99999' :value="$store.state.global_overlay">
        <v-row
          ><v-col
            ><v-alert border="top" colored-border type="info" elevation="2"
              >{{ $store.state.global_overlay_text }}&nbsp;<v-progress-circular
                :indeterminate="true"
                :rotate="0"
                :size="32"
                :width="4"
                color="primary"
              ></v-progress-circular></v-alert></v-col
        ></v-row>
      </v-overlay>
      <v-fade-transition mode="out-in">
      <router-view name="main"/>
      </v-fade-transition>
      </v-main>
      <router-view v-if="!embedded" name="footer"/>
      
    </v-app>
</template>

<script>
import { isEmbedded } from "./services/embeddedNavigation";

export default {
  name: 'app',
  data: () => ({
      expandOnHover: true,
      versionMismatch: false,
  }),
  computed: {
    embedded() {
      return isEmbedded();
    }
  },
  mounted() {
    window.addEventListener('app-version-mismatch', this.showVersionMismatch);
  },
  beforeDestroy() {
    window.removeEventListener('app-version-mismatch', this.showVersionMismatch);
  },
  methods: {
    showVersionMismatch() {
      this.versionMismatch = true;
    },
    reloadApplication() {
      window.location.reload();
    },
  }
}
</script>

<style lang="scss">
@import 'sass/variables.scss';
@import 'assets/app.scss';
@import 'assets/app.css';
</style>

<style>
.profile-gravatar {
  width: 48px;
  height: 48px;
}

.profile-container {
  display: flex;
  align-items: center;
  text-align: left;
  padding: 0px;
  margin: 2px;
}

.profile-circle {
  text-align: left;
  background: #39a7eb;
  border: 0.5px solid gray;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: inline-block;
  text-align: left;
}

.profile-text {
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  line-height: 30px;
}

.profile-name {
  display: inline-block;
  align-items: center;
  margin-left: 5px;
}
</style>
